import { FC } from "react";
import {
  getCalenderModeVal,
  getDateModeFormat,
} from "../../../helpers/datetime";
import { Button, Popover, RadioButton } from "../../ui";
import CalendarDayWidget from "./calendar_days_widget";
import CalendarMonthWidget from "./calendar_months_widget";
import CalendarYearWidget from "./calendar_years_widget";
import { TCalendarType, TDateType } from "./calendar_types";
import moment from "moment";

const CalendarModal: FC<{
  showCalendar: boolean;
  setShowCalendar: (val: boolean) => void;
  calendarMode: string;
  setCalendarMode: (val: string) => void;
  fromDate: string;
  toDate: string;
  onApply: () => void;
  onSelectDate: (
    date: string,
    mode: TCalendarType,
    dateType?: TDateType,
    toDate?: string,
  ) => void;
  hideModes: boolean;
  hideMargin?: boolean;
}> = ({
  showCalendar,
  setShowCalendar,
  calendarMode,
  setCalendarMode,
  fromDate,
  toDate,
  onApply,
  onSelectDate,
  hideModes,
  hideMargin,
}) => {
  const calendarModes = [
    { label: "All", value: "ALL" },
    { label: "Daily", value: "DAILY" },
    { label: "Weekly", value: "WEEKLY" },
    { label: "Monthly", value: "MONTHLY" },
    { label: "Yearly", value: "YEARLY" },
    { label: "Custom", value: "CUSTOM" },
  ];

  return (
    <Popover
      style={{ width: "46rem" }}
      open={showCalendar}
      onClose={() => setShowCalendar(false)}
    >
      <div className="flex flex-col bg-white rounded-lg max-h-[calc(100dvh-16px)]">
        {!hideModes && (
          <div className="flex justify-center p-3 bg-light-white shrink-0">
            <RadioButton
              value={calendarMode}
              data={calendarModes}
              pointer={{ label: "label", value: "value" }}
              onChange={(v) => {
                setCalendarMode(v.toString());
              }}
              styles={{ display: "flex" }}
              radioClasses="mr-3"
            />
          </div>
        )}

        <div className="border-t shrink-0" />

        <div className="flex-1 min-h-0 overflow-y-auto">
          {(calendarMode === "ALL" || calendarMode === "CUSTOM") && (
            <div className="flex">
              <div className="w-1/2 min-w-0">
                <CalendarDayWidget
                  date={fromDate}
                  calendarMode={calendarMode}
                  onSelectDate={(date) => {
                    onSelectDate(date, calendarMode, "FROM");
                  }}
                  dateType="FROM"
                  toDate={toDate}
                />
              </div>

              <div className="w-1/2 min-w-0">
                <CalendarDayWidget
                  date={toDate}
                  calendarMode={calendarMode}
                  onSelectDate={(date) => {
                    onSelectDate(date, calendarMode, "TO");
                  }}
                  label="To"
                  dateType="TO"
                  toDate={fromDate}
                />
              </div>
            </div>
          )}

          {(calendarMode === "DAILY" || calendarMode === "WEEKLY") && (
            <CalendarDayWidget
              date={fromDate}
              calendarMode={calendarMode}
              onSelectDate={(date, dateType, toDate) => {
                onSelectDate(date, calendarMode, dateType, toDate);
              }}
              toDate={toDate}
              hideMargin={hideMargin}
            />
          )}

          {calendarMode === "MONTHLY" && (
            <CalendarMonthWidget
              fromDate={fromDate}
              onSelecteMonth={(date) => {
                onSelectDate(date, calendarMode);
              }}
            />
          )}

          {calendarMode === "YEARLY" && (
            <CalendarYearWidget
              fromDate={fromDate}
              onSelectYear={(date) => {
                onSelectDate(date, calendarMode);
              }}
            />
          )}
        </div>

        <div className="border-t shrink-0" />

        <div className="flex items-center justify-between gap-3 p-3 shrink-0 bg-white">
          <div className="flex fs-14 min-w-0">
            <span className="shrink-0">
              Selected {getCalenderModeVal(calendarMode)}:
            </span>

            <span className="font-bold ml-1 min-w-0">
              {calendarMode === "WEEKLY" ? (
                <span>
                  {moment(fromDate).format("DD-MMM-YYYY")} -{" "}
                  {moment(toDate).format("DD-MMM-YYYY")}
                </span>
              ) : calendarMode === "CUSTOM" ? (
                <span>
                  From: {moment(fromDate).format("DD-MMM-YYYY")} To:{" "}
                  {moment(toDate).format("DD-MMM-YYYY")}
                </span>
              ) : (
                getDateModeFormat(calendarMode, fromDate, toDate)
              )}
            </span>
          </div>

          <div className="shrink-0">
            <Button onClick={onApply}>Apply</Button>
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default CalendarModal;
